export const SET_ENVIRONMENT_DEVELOPMENT = "development";
export const SET_ENVIRONMENT_DEVELOPMENT_LABEL = "Desarrollo";
export const SET_ENVIRONMENT_PRODUCTION = "production";
export const SET_ENVIRONMENT_PRODUCTION_LABEL = "Producción";

export const SET_ENVIRONMENT_CHOICES: Map<string, string> = new Map([
  [SET_ENVIRONMENT_DEVELOPMENT, SET_ENVIRONMENT_DEVELOPMENT_LABEL],
  [SET_ENVIRONMENT_PRODUCTION, SET_ENVIRONMENT_PRODUCTION_LABEL],
]);
